
'use client'
import Image from 'next/image';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import brandBanner from '@/assets/images/bee-.png';
import bannerBg from '@/assets/images/login-pattern.png';
import { useTranslation } from '@/Utils/Hooks/useTranslate';
import { useLoading } from '@/Utils/Hooks/useLoading';
import SkeletonLoader from '@/Layout/SkeletonLoader';

const AuthRightSide = (props) => {
    const { userDetails } = props
    const { translations } = useTranslation();
    const { skeletonLoading, startSkeletonLoading, stopSkeletonLoading } = useLoading();
    const pathname = usePathname();
    const roleFromUrl = pathname.split('/')[2];

    useEffect(() => {
        startSkeletonLoading();
        setTimeout(() => {
            stopSkeletonLoading();
        }, 1000);
    }, []);

    if ((userDetails?.pending_steps == 0 || userDetails?.pending_steps == 2) && userDetails?.is_verify_otp && roleFromUrl == 'influencer') {
        return null
    }
    return (
        <>
            {skeletonLoading ? <SkeletonLoader height='100%' rows={1} /> :
                <div className="max-xl:hidden flex flex-col justify-between relative overflow-hidden bg-gradient-to-br from-primary via-[#a668ff] to-accent bg-[length:200%_200%] animate-gradient-shift">
                    <span aria-hidden className='pointer-events-none absolute -top-24 -left-24 h-96 w-96 rounded-full bg-white/20 blur-3xl'></span>
                    <span aria-hidden className='pointer-events-none absolute -bottom-32 -right-10 h-[28rem] w-[28rem] rounded-full bg-accent/50 blur-3xl'></span>
                    <Image src={bannerBg} alt='pattern' className='pointer-events-none w-full h-full absolute top-0 left-0 object-cover opacity-20' priority />

                    <div className='relative flex flex-col 2xl:pt-24 pt-16 2xl:px-20 px-14 gap-8 z-10'>
                        <span className='inline-flex w-fit items-center gap-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 px-4 py-2 text-xs uppercase tracking-[0.22em] font-semibold text-white'>
                            ✨ {translations?.creatorClub || 'Connector Club'}
                        </span>
                        <h2
                            className='text-display font-bold !leading-[1.05] 2xl:text-5xl lg:text-4xl text-3xl text-white relative z-10'
                            dangerouslySetInnerHTML={{ __html: translations.authSidebarTitle }}
                        />

                        <div className='hidden 2xl:flex gap-4 flex-wrap max-w-md'>
                            <div className='rounded-2xl bg-white/15 backdrop-blur-md border border-white/20 px-5 py-3 flex flex-col'>
                                <span className='text-display text-2xl font-bold text-white'>50k+</span>
                                <span className='text-[11px] uppercase tracking-[0.18em] font-semibold text-white/75'>{translations?.creators || 'Creators'}</span>
                            </div>
                            <div className='rounded-2xl bg-white/15 backdrop-blur-md border border-white/20 px-5 py-3 flex flex-col'>
                                <span className='text-display text-2xl font-bold text-white'>500+</span>
                                <span className='text-[11px] uppercase tracking-[0.18em] font-semibold text-white/75'>{translations?.brands || 'Brands'}</span>
                            </div>
                            <div className='rounded-2xl bg-white/15 backdrop-blur-md border border-white/20 px-5 py-3 flex flex-col'>
                                <span className='text-display text-2xl font-bold text-white'>100+</span>
                                <span className='text-[11px] uppercase tracking-[0.18em] font-semibold text-white/75'>{translations?.countries || 'Active Jobs'}</span>
                            </div>
                        </div>
                    </div>

                    <Image src={brandBanner} alt='Login Banner' className='w-full 4xl:max-w-3xl 2xl:max-w-2xl max-w-xl ml-auto relative z-10 drop-shadow-[0_30px_60px_rgba(0,0,0,0.25)]' priority />
                </div>
            }
        </>
    )
}

export default AuthRightSide
